export const environment = {
  appName: 'city-card-app',
  envName: 'DEV',
  assetsPath: '/public/',
  production: false,
  test: false,
  i18nPrefix: '',
  googleMapsApiKey: 'AIzaSyBZr3hzsk5paz-g0DD4VQr1h6hQNztRsAY',
  apiConfigs: {
    API_URL: 'https://testapi.incust.com/v1/client',
    PLATFORM_URL: 'https://testapi.incust.com/v1',
    AUTH_URL: 'https://testapi.incust.com/v1/user'
  },
  tabsConfig: [
    { name: 'pos-map', icon: 'map-outline', main: false, label: 'app#city_card#tabs#pos_map' },
    { name: 'pos-list', icon: 'layers-outline', main: false, label: 'app#city_card#tabs#pos_list' },
    { name: 'cart', icon: 'card-outline', main: false, label: 'app#city_card#tabs#card' },
    { name: 'profile', icon: 'menu-outline', main: false, label: 'app#city_card#tabs#menu' }
  ]
};
